import React from 'react';
import { useNavigate } from 'react-router';

import BaseLayout from '../BaseLayout';

const LandingLayout = ({ children }: any) => {
  const navigate = useNavigate();

  return (
    <BaseLayout type="app" onLogout={() => navigate('/logout')}>
      {children}
    </BaseLayout>
  );
};

export default LandingLayout;
